import React from "react";
import { Link } from "react-router-dom";
import "../style.css";
import { FaInstagram, FaTiktok } from "react-icons/fa";
// Import the badge asset
import appStoreBtn from "../assets/App-Store-Download.png"; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* LEFT SIDE: Vertical stack of Top Row, App Store Badge, and Copyright */}
        <div className="footer-left">
          <div className="footer-top-row">
            <span className="footer-logo">QUICKFIT</span>
            <nav className="footer-nav">
              <Link to="/brands">Brands</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/about">About</Link>
              <Link to="/support">Support</Link>
            </nav>
          </div>

          {/* App Store Badge Row */}
          <div className="footer-download">
            <a 
              href="https://apps.apple.com/us/app/quickfit-inc/id6745117626" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-store-link"
            >
              <img 
                src={appStoreBtn} 
                alt="Download on the App Store" 
                className="app-store-img"
              />
            </a>
          </div>

          <p className="copyright">&copy; 2026 QuickFit. All rights reserved.</p>
        </div>

        {/* RIGHT SIDE: Social Icons */}
        <div className="footer-right">
          <a 
            href="https://www.instagram.com/quickfit_app" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a 
            href="https://www.tiktok.com/@quickfit_app?lang=en" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="TikTok"
          >
            <FaTiktok />
          </a>
        </div>

      </div>
    </footer>
  );
};

export default Footer;